import type { ClassNameProp } from '@library/types'
import cn from 'classnames'
import type { Prettify } from 'common/types'
import type { PropsWithChildren, ReactNode } from 'react'
import { forwardRef } from 'react'

import css from './ModalButton.css'
import { ModalHeader } from './ModalHeader'

type ModalButtonProps = Prettify<
  ClassNameProp & {
    expanded: boolean
    title: string
    headerSlot?: ReactNode
    handleOpen: VoidFunction
    handleClose: VoidFunction
  }
>

export const ModalButton = forwardRef<HTMLDivElement, PropsWithChildren<ModalButtonProps>>(
  function ModalButton(
    { className, expanded, children, headerSlot, handleClose, handleOpen, title },
    ref,
  ) {
    const contentClass = cn(css.content, { [css.hidden]: !expanded })
    return (
      <div ref={ref} className={cn(css.button, { [css.expanded]: expanded }, className)}>
        <ModalHeader
          title={title}
          expanded={expanded}
          handleClose={handleClose}
          handleOpen={handleOpen}>
          {headerSlot}
        </ModalHeader>
        <div className={contentClass}>{children}</div>
      </div>
    )
  },
)
